import { axiosInstance } from '../../../common/axiosInstans.ts';

export interface Feedback {
    id: string;
    tenantId: string;
    type: string;
    category: string;
    priority: string;
    status: string;
    title: string;
    description?: string;
    stepsToReproduce?: string;
    expectedBehavior?: string;
    actualBehavior?: string;
    note?: string;
    userName?: string;
    userEmail?: string;
    timestamp?: string;
    appVersion?: string;
    platform?: string;
}

export class FeedbackService {
    getAll = async (): Promise<Feedback[]> => {
        const response = await axiosInstance.get('/feedback');
        return response.data;
    };

    getById = async (id: string): Promise<Feedback> => {
        const response = await axiosInstance.get(`/feedback/${id}`);
        return response.data;
    };

    updateStatus = async (
        id: string,
        status: string,
        note?: string
    ): Promise<string> => {
        const response = await axiosInstance.put(`/feedback/${id}/status`, {
            status,
            note,
        });
        return response.data;
    };
}
